import BizToplist from './BizToplist';
import { ToplistConfig } from '../../Types/leaderboard';
import './biz-profile-toplists.scss';

/**
 * Toplist configuration for the profile page
 * All use 'unit' scope with different time ranges
 */
const getProfileToplistConfigs = (): { config: ToplistConfig; title: string }[] => {
	const now = new Date();
	const currentYear = now.getFullYear();
	const currentMonth = now.getMonth();

	// Start of current month
	const startOfMonth = new Date(currentYear, currentMonth, 1);

	// Start of current year
	const startOfYear = new Date(currentYear, 0, 1);

	// End of today (23:59:59)
	const endOfToday = new Date(currentYear, currentMonth, now.getDate(), 23, 59, 59);

	return [
		{
			config: {
				scope: 'unit',
				fromDate: startOfMonth,
				toDate: endOfToday,
				limit: 10,
			},
			title: 'This Month',
		},
		{
			config: {
				scope: 'unit',
				fromDate: startOfYear,
				toDate: endOfToday,
				limit: 10,
			},
			title: 'This Year',
		},
		{
			config: {
				scope: 'unit',
				limit: 10,
			},
			title: 'All Time',
		},
	];
};

type BizProfileToplistsProps = {
	/** Legacy mode for AngularJS integration */
	legacy?: boolean;
};

/**
 * BizProfileToplists Component
 *
 * Renders 3 toplists for the profile page:
 * - All Time (unit scope, no date filter)
 * - This Month (unit scope, current month)
 * - This Year (unit scope, current year)
 *
 * This component is specifically designed for the profile leaderboards page
 * and wraps multiple BizToplist components in a single loader-friendly container.
 *
 * @example
 * ```tsx
 * // In a loader file:
 * AddBizReactLoader(root, 'bizprofiletoplists', () => {
 *   return withFrontendContext(<BizProfileToplists legacy />);
 * });
 * ```
 */
const BizProfileToplists = ({ legacy = false }: BizProfileToplistsProps) => {
	const toplistConfigs = getProfileToplistConfigs();

	return (
		<div className={`biz-profile-toplists ${legacy ? 'legacy' : ''}`}>
			{toplistConfigs.map((item, index) => (
				<div key={index} className='biz-profile-toplists-item'>
					<BizToplist config={item.config} title={item.title} legacy={legacy} />
				</div>
			))}
		</div>
	);
};

export default BizProfileToplists;
